"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "infoCommand", {
    enumerable: true,
    get: function() {
        return command;
    }
});
const _commander = require("commander");
const _action = require("./action.js");
const _addOptions = require("../addOptions.js");
const command = new _commander.Command("info");
(0, _addOptions.addOptions)("server", command);
(0, _addOptions.addOptions)("runner", command);
(0, _addOptions.addOptions)("logger", command);
(0, _addOptions.addOptions)("filter", command);
(0, _addOptions.addOptions)("info", command);
command.action(_action.infoAction);
